// Known personal/consumer email providers. Business (work) emails use company domains.
export const ALLOWED_PERSONAL_TEST_EMAILS = new Set(["alputov1998@gmail.com"]);

export const CONSUMER_EMAIL_DOMAINS = new Set([
  // Google
  "gmail.com",
  "googlemail.com",
  // Microsoft personal
  "outlook.com",
  "hotmail.com",
  "hotmail.co.uk",
  "hotmail.fr",
  "hotmail.de",
  "hotmail.it",
  "hotmail.es",
  "hotmail.com.au",
  "live.com",
  "live.co.uk",
  "live.fr",
  "live.de",
  "live.ca",
  "live.com.au",
  "msn.com",
  "windowslive.com",
  // Yahoo
  "yahoo.com",
  "yahoo.co.uk",
  "yahoo.co.in",
  "yahoo.com.au",
  "yahoo.com.br",
  "yahoo.com.mx",
  "yahoo.com.ar",
  "yahoo.fr",
  "yahoo.de",
  "yahoo.it",
  "yahoo.es",
  "yahoo.ca",
  "yahoo.co.jp",
  "yahoo.gr",
  // Apple
  "icloud.com",
  "me.com",
  "mac.com",
  // AOL
  "aol.com",
  "aol.co.uk",
  // ProtonMail
  "protonmail.com",
  "protonmail.ch",
  "proton.me",
  "pm.me",
  // GMX
  "gmx.com",
  "gmx.net",
  "gmx.de",
  "gmx.at",
  "gmx.ch",
  "gmx.fr",
  // German providers
  "web.de",
  "freenet.de",
  "t-online.de",
  // Russian providers
  "mail.ru",
  "bk.ru",
  "inbox.ru",
  "list.ru",
  "yandex.ru",
  "yandex.com",
  "ya.ru",
  "rambler.ru",
  // Chinese providers
  "qq.com",
  "163.com",
  "126.com",
  "sina.com",
  "sohu.com",
  // Other common free providers
  "mail.com",
  "aim.com",
  "inbox.com",
  "tutanota.com",
  "tutamail.com",
  "tuta.io",
]);
